import React, { useState, useRef, useEffect, forwardRef } from 'react';
import '../Tab Content/Subflow Template Contents/Subflow Template Creation.css';
import FilterPreview from "./Filter_Preview";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import CustomSelect from '../Customized Components/CustomSelect';
import SaveTemplate from './SaveTemplate';
import SubflowTemplateServiceController from '../../Controllers/SubflowTemplateService';
import SingleSelectDropdown from './SingleSelectDropdown';
import WorkflowTemplateServiceController from '../../Controllers/WorkflowTemplateservice';
import { Info } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import EventServiceController from './../../Controllers/EventService';
import CustomToaster, { notify } from './Custom_Toaster';

const CanvasHeader = forwardRef((props, ref) => {
  let { savedName, isEdit, isClone, openNoLevelsPopup, handleSelectChange, handleSelectEventLevelChanges, selectedValues,
    workFlowId, clientId, backClick, saveJson, backButtonLabel, versionId,
    client, department, isTransaction, isSubflow, event, fromSubflow, eventName,
    imgForPreview, handleInputCalloutName, isWorkflowChanged, isClientChanged,
    handleSaveFilters, addFilters, workflowTemplateId, saveValidations, isSaveDialogOpen, closeDialog, emailData, handleNoteClick, handleVersionChange, selectedVersionId, Level, calloutNameWorkFlowTemplate, defaultTemplateView, handleDefaultTempchange, selectedDefualtTempId, ...rest } = props;


  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const workflowCanvasRef = useRef(null);
  const subflowTempcont = new SubflowTemplateServiceController();
  const workflowTempCont = new WorkflowTemplateServiceController();
  const [filterDropdownValues, setFilterDropdownValues] = useState([]);
  const [isVersionDisabled, setIsVersionDisabled] = useState(false);

  const [workflow, setWorkflow] = useState([
    { label: "--select--", value: "--select--", dropdownId: "0", versionId: "0", calloutName: "0" },
  ]);

  const [level, setLevel] = useState([
    { label: "--select--", value: "--select--", dropdownId: "0" },
  ]);
  const [clients, setClients] = useState([
    { label: "--select--", value: "--select--", id: "0" },
  ]);
  const [dept, setDept] = useState([
    { label: "--select--", value: "--select--", id: "0" },
  ]);
  const [version, setVersion] = useState([
    { label: "", value: "0" },
  ]);

  const [emptyVersion, setemptyVersion] = useState([
    { label: "", value: "0" },
  ]);
  useEffect(() => {
    setSaveDialogOpen(isSaveDialogOpen);
  }, [isSaveDialogOpen]);

  const getDropdownValuesforSubflow = async () => {
    const workflowDropdowns = await subflowTempcont.getSubflowTemplateDropdownValuesWorkflow();
    setWorkflow(
      Array.isArray(workflowDropdowns) && workflowDropdowns.length > 0
        ? [
          { label: "--select--", value: "--select--", dropdownId: "0" }, // Initial client value
          ...workflowDropdowns.map((item) => ({
            label: item.templateName + "(V" + item.versionId + ")",
            value: item.templateName + "(V" + item.versionId + ")",
            dropdownId: item.id,
            versionId: item.versionId,
            calloutName: item.calloutName,
          })),
        ]
        : [
          {
            label: client ?? "--select--",
            value: client ?? "--select--",
            dropdownId: "0",
          },
        ] // Dummy option if body is empty
    );
  };

  const getDropdownValuesforWorkflow = async () => {
    // Fetch workflow dropdown values  
    const clientDropdowns = await workflowTempCont.getWorkflowTemplateDropdownValuesClient();
    setClients(
      Array.isArray(clientDropdowns) && clientDropdowns.length > 0
        ? [
          { label: "--select--", value: "--select--", id: "0" }, // Initial client value
          ...clientDropdowns.map((item) => ({
            label: item.name,
            value: item.name,
            id: item.id,
          })),
        ]
        : [
          {
            label: client ?? "--select--",
            value: client ?? "--select--",
            id: "0",
          },
        ] // Dummy option if body is empty
    );

    // Load all departments 
    const deptDropdowns =
      await workflowTempCont.getWorkflowTemplateDropdownValuesDept();

    setDept(
      Array.isArray(deptDropdowns) && deptDropdowns.length > 0
        ? [
          { label: "--select--", value: "--select--", id: "0" },
          ...deptDropdowns.map((item) => ({
            label: item.name,
            value: item.name,
            id: item.id,
          })),
        ]
        : [{ label: "--select--", value: "--select--", id: "0" }]
    );

    // Keep filter loading only if client is selected
    if (clientId !== "0") {
      const filterDropdownValue =
        await workflowTempCont.getWorkflowTemplateFilterDropdownValues(clientId);

      setFilterDropdownValues(filterDropdownValue);
    }

    if (workflowTemplateId !== "0") {
      const response =
        await workflowTempCont.getWorkflowTemplateDropdownValuesVersion(workflowTemplateId);

      const versionDropdowns = Array.isArray(response)
        ? response
        : response?.data || [];

      if (versionDropdowns.length > 0) {
        setIsVersionDisabled(false);

        const sortedVersions = versionDropdowns
          .filter((item) => item?.versionId !== undefined)
          .sort((a, b) => Number(b.versionId) - Number(a.versionId));

        setVersion(
          sortedVersions.map((item) => ({
            label: item.versionId,
            value: String(item.versionId), // force string
          }))
        );
      } else {
        setIsVersionDisabled(true);
        setVersion([{ label: "", value: "0" }]);
      }
    }
    if (workflowTemplateId !== "0") {
      const response = await workflowTempCont.getWorkflowTemplateDropdownValuesVersion(workflowTemplateId);

      const versionDropdowns = Array.isArray(response)
        ? response
        : response?.data || [];

      if (versionDropdowns.length > 0) {
        setIsVersionDisabled(false);

        const sortedVersions = versionDropdowns
          .filter((item) => item?.versionId !== undefined)
          .sort((a, b) => Number(b.versionId) - Number(a.versionId));

        setVersion(
          sortedVersions.map((item) => ({
            label: item.versionId,
            value: String(item.versionId), // force string
          }))
        );

      } else {
        setIsVersionDisabled(true);
        setVersion([{ label: "", value: "0" }]);
      }
    }
  };

  useEffect(() => {
    (fromSubflow) ?
      getDropdownValuesforSubflow() : getDropdownValuesforWorkflow();

  }, [workFlowId, clientId, client, department]);


  useEffect(() => {
    // Reset level dropdown values when workflow changes
    if (!event && isWorkflowChanged) {
      setLevel([{ label: "--select--", value: "--select--", dropdownId: "0" }]);
      handleSelectChange(level[0], "selectedLevel");
    }
  }, [workFlowId, isWorkflowChanged, clientId, isClientChanged, versionId, version]);


  const [openFilter, setOpenFilter] = useState(false);
  useEffect(() => {
  }, [workflowCanvasRef,]);

  const handleApplyFilters = () => {
    handleSaveFilters();
    handleFilterClick();
  }

  const handleFilterClick = () => {
    setOpenFilter(!openFilter);
  };

  const handleSaveClick = async () => {
    if (
      backButtonLabel.trim() === "Workflow Template List" ||
      backButtonLabel.trim() === "Subflow Template List"
    ) {
      imgForPreview();
      if (saveValidations()) {
        saveJson();
      }      
    } else if (backButtonLabel.trim() === "Event List") {
      saveValidations(eventName);
    } else {
      saveJson();
    }
  };

  const handleCloseDialog = () => {
    closeDialog();
    setSaveDialogOpen(false);
  }
  // Added tooltip for  "Add Filters Button" to indicate if predefined filters available inside.
  // const getTooltipTitle = () => {
  //   const filtersChecked = addFilters.some(filter =>
  //     filter.criteria.length > 0
  //   ) ? 'filters available' : 'no filters available';
  //   return filtersChecked;
  // };
  // const handleCreateConsolidatedJson = async (id) => {
  //   const body = await workflowTempCont.getConsolidatedWorkflow(id);
  // }

  useEffect(() => {
    if ((isEdit || isClone) && isSubflow) {
      if (versionId) {
        setVersion([{ label: versionId, value: versionId }]);
      }
    }
  }, [isEdit, isClone, isSubflow, versionId]);

  return (
    <>
      <div className="transaction-header" style={{ cursor: "pointer" }}>
        <p onClick={backClick}>
          <span className="back-arrow">
            <FaRegArrowAltCircleLeft style={{ fontSize: '25px' }} />
          </span>
          {backButtonLabel}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: 'fit-content' }}>
          <button type="button" onClick={handleSaveClick} className="save-button">

            {isClone
              ? "Clone"
              : isEdit
                ? "Update"
                : "Save"
            }
          </button>
        </div>
      </div>
      {!event &&
        (isTransaction ? (
          <div className="input-row">
            <div className="input-item">
              <label>Client</label>
              <input type="text" value={client} readOnly />{" "}
            </div>
            <div className="input-item">
              <label>Department</label>
              <input type="text" value={department} readOnly />{" "}
            </div>
            <div className="input-item">
            </div>
          </div>
        ) : !isSubflow ? (
          <div className="dropdown-row" style={{ display: "flex", gap: "20px", width: "100%" }}>
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <div stye={{ display: "flex", flexDirection: "column" }}>
                <p>Client</p>
                <SingleSelectDropdown
                  options={clients}
                  onChange={(value) => handleSelectChange(value, "selectedClient")}
                  valueSet={selectedValues.selectedClient}
                  tskCtg={false}
                  placeHolder={selectedValues.selectedClient.label ?? clients[0].label}
                  addCandInfo={false}
                  isEdit={isEdit}
                  relevantId={clientId}
                />
              </div>
              <div stye={{ display: "flex", flexDirection: "column" }}>
                <p>Department</p>
                <SingleSelectDropdown
                  options={dept}
                  onChange={(value) => handleSelectChange(value, "selectedDept")}
                  valueSet={selectedValues.selectedDept}
                  tskCtg={false}
                  placeHolder={selectedValues.selectedDept.label ?? dept[0].label}
                  addCandInfo={false}
                  isEdit={isEdit}
                  relevantId={clientId}
                />
              </div>
              {selectedVersionId != null && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <p>Version</p>
                  {Array.isArray(version) && version.length > 0 ? (
                    <select
                      value={String(selectedVersionId ?? "0")}
                      onChange={(e) => handleVersionChange(e.target.value)}
                      disabled={!!selectedVersionId}   // 👈 key line

                      style={{
                        flex: 1,
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        width: "100%",
                      }}
                    >
                      {version.map((event) => (
                        <option key={event.value} value={event.value}>
                          {event.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <p>No versions available</p>
                  )}
                </div>)}
              {selectedVersionId == null && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <p>Default Templates</p>
                  {/* defaultTemplateView */}
                  {Array.isArray(defaultTemplateView) && defaultTemplateView.length > 0 ? (
                    <select
                      value={selectedDefualtTempId}
                      onChange={(e) => handleDefaultTempchange(e.target.value)}
                      disabled={!!selectedDefualtTempId}   // optional
                      style={{
                        flex: 1,
                        padding: "6px 10px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        width: "250px",
                      }}
                    >

                      <option selected>-- Select Default Template --</option>
                      {defaultTemplateView.map((event) => (
                        <option key={event.id} value={event.id}>
                          {event.name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <select style={{
                      flex: 1,
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%",
                    }}
                    >
                      <option selected>-- No Default Template --</option>
                    </select>
                  )}
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
              <button
                className="add-note-btn"
                onClick={handleNoteClick}
                style={{
                  padding: "8px 16px",
                  color: "#02ACF6",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  alignSelf: "flex-end",
                  fontWeight: "600",
                }}
              >
                + Add Note
              </button>
            </div>
            {/* <div className="filter-button" style={{background: clientId  === '0' ? "#fcf6f7": "#f3fbff"}} onClick={clientId === '0'? null : handleFilterClick}>
              <p style={{color : clientId  === '0' ? '#757ea5' :' #02acf6',cursor: clientId  === '0' ? 'default' :' pointer',padding:'5px'}}>Add Filter</p>
              <div style={{position:'absolute',right:-10,bottom:10}}>
              <Tooltip title= {getTooltipTitle()}>
              <Info style={{color: getTooltipTitle().includes("no") ? "#757ea5":"#02acf6",fontSize:'18px'}}/>
              </Tooltip>
            </div>
            </div> */}
            <FilterPreview openPre={openFilter} closePre={handleFilterClick} filterDropdownValues={filterDropdownValues} ref={ref} handleApplyFilters={handleApplyFilters} isEdit={isEdit} addFilters={addFilters} workflowTemplateId={workflowTemplateId} />
          </div>
        ) : (
          <div className="dropdown-row">
            <div stye={{ display: "flex", flexDirection: "column", width: "50% !important" }}>
              <p>Workflow</p>

              <SingleSelectDropdown
                options={workflow}
                onChange={(value) => handleSelectChange(value, "selectedWorkflow")}
                valueSet={selectedValues.selectedWorkflow}
                tskCtg={false}
                placeHolder={selectedValues.selectedWorkflow.label ?? workflow[0].label}
                addCandInfo={false}
                isEdit={isEdit}
                relevantId={workFlowId}
              />
            </div>


            <div style={{ display: "flex", flexDirection: "column" }}>
              <p>Workflow Callout Name</p>

              <input
                type="text"
                disabled={true}
                value={calloutNameWorkFlowTemplate}
                style={{
                  flex: 1,
                  padding: "6px 10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  width: "100%",
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p>Level</p>

              {calloutNameWorkFlowTemplate ? (
                <SingleSelectDropdown
                  options={Level} // you can filter this based on selectedWorkflow if needed
                  onChange={(value) => handleSelectEventLevelChanges(value, "selectedLevel")}
                  valueSet={selectedValues.selectedLevel}
                  tskCtg={false}
                  placeHolder={selectedValues.selectedLevel?.label ?? Level?.[0]?.label}
                  addCandInfo={false}
                  isEdit={isEdit}
                  relevantId={workFlowId}
                />
              ) : (
                <input
                  type="text"
                  disabled
                  placeholder="Select Workflow first"
                  style={{
                    flex: 1,
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    width: "100%",
                    backgroundColor: "#f5f5f5",
                  }}
                />
              )}
            </div>
          </div>
        ))}
      {backButtonLabel !== "Tasks List" && (
        <SaveTemplate
          heading={
            backButtonLabel === "Workflow Template List"
              ? "Save Workflow Template"
              : backButtonLabel === "Subflow Template List"
                ? "Save Subflow Template"
                : "Save Event"
          }
          open={saveDialogOpen}
          onClose={handleCloseDialog}
          onSave={saveJson}
          eventName={eventName}
          savedName={savedName}
          handleInputChange={handleInputCalloutName}
        />
      )}
    </>
  );
});

export default CanvasHeader